import {
  UPDATE_SWITCH_FUNCTION_WHITELIST_SUCCESS,
  SWITCH_FUNCTION_SHOP_CHECKING,
  SWITCH_FUNCTION_SHOP_CHECKING_SUCCESS,
  SWITCH_FUNCTION_SHOP_CHECKING_CLEAR,
  UPDATE_SWITCH_FUNCTION_WHITELIST_CLEAR,

  PREMIUM_SHOP_GET_CHAIN_SHOP_LIST_SUCCESS,
} from 'actions/advancedFunction';


export const advancedFunction = (previousState = {}, { type, payload }) => {
  switch (type) {
    case UPDATE_SWITCH_FUNCTION_WHITELIST_SUCCESS:
      return {...payload, updateWhitelistSuccess: true};
    case UPDATE_SWITCH_FUNCTION_WHITELIST_CLEAR:
      return {};
    case SWITCH_FUNCTION_SHOP_CHECKING:
      return payload;
    case SWITCH_FUNCTION_SHOP_CHECKING_SUCCESS:
      return {shopCheckedResults: payload.data};
    case SWITCH_FUNCTION_SHOP_CHECKING_CLEAR:
      return {shopCheckedResults: null};
    case PREMIUM_SHOP_GET_CHAIN_SHOP_LIST_SUCCESS:
      return {
        ...previousState,
        currentChainShopList: payload.data,
      };
    default:
      return previousState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/advancedFunction/index.js